import * as React from "react"
import BasicTextModule from "../../components/BasicTextModule/BasicTextModule"
import { GatsbyImage, getImage ,StaticImage} from 'gatsby-plugin-image'
//import Button from "../Button/Button"
import { BasicTextGalleryModuleStyles } from "./BasicTextGalleryModuleStyles"
//import { Link } from "gatsby"
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

import { Gallery, Item } from 'react-photoswipe-gallery'


const BasicTextGalleryModule = (data) => {
   
    const prepareImg = (obj) => {
        return {
          original: obj.localFile.childrenImageSharp[0].original.src,
          thumbnail: obj.localFile.childrenImageSharp[0].resize.src,
          originalW: obj.localFile.childrenImageSharp[0].original.width,
          originalH: obj.localFile.childrenImageSharp[0].original.height,
        };
      }
    console.log("data.images",data.images)
    let imgs = data.images.map(prepareImg);
    //  const image = getImage(props.images.childrenImageSharp[0])
  
    return (
        <BasicTextGalleryModuleStyles className="nomargin section" id={data.id?data.id : "gallery-text"}>
            <div className="container container-wrapper" >
                <div className="section lg ps-md-0">
                    <h2 dangerouslySetInnerHTML={{ __html: data.titolo }}></h2>
                   {/*  {data.content.map((item, index) => (
                        <BasicTextModule key={index}  className="last-text" marginBottomText="0px" content={ item.paragrafo } ></BasicTextModule>
                    ))}  */}
                    <BasicTextModule className="last-text" marginBottomText="0px" content={ data.content } ></BasicTextModule>
                </div>
                <div className="section sm ps-md-0" style={{textAlign:"center"}}>

                    <div className={"gallery "+data.classe_gallery}>
                        <Gallery >
                            {imgs.map( child => (

                            <Item
                                key={child.original}
                                original={child.original}
                                thumbnail={child.thumbnail}
                                width={child.originalW}
                                height={child.originalH}
                            >
                                {({ ref, open }) => (
                                <img ref={ref} onClick={open} src={child.thumbnail} />
                                )}
                            </Item>
                            ))
                            }

                        </Gallery>
                    </div>
                </div>
            </div>
        </BasicTextGalleryModuleStyles>
    )
}

export default BasicTextGalleryModule
